import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UserService } from '../../core/user/user.service';
import { SubscriptionService } from '../../core/subscription/subscription.service';
import { SubscriptionInterval } from '../../core/subscription/subscription';
import { SubscriptionPlansCheckoutComponent } from '../subscription/subscription-plans-checkout/subscription-plans-checkout.component';

// "Choose a plan" block (ENG-2292, Figma 19659-76494): heading, trust bullets,
// the monthly/annual toggle and the plan grid with the "Recommended for you"
// banner on the API-recommended plan. Used by the unified Go Live step and the
// Billing tab's no-card trial state.
@Component({
    selector: 'rosie-choose-plan-section',
    templateUrl: './choose-plan-section.component.html',
    styleUrls: ['./choose-plan-section.component.scss'],
    standalone: false
})
export class ChoosePlanSectionComponent {
    // Lowercase plan key from the API ('scale' | 'professional'). Falls back to
    // Scale when nothing is provided.
    @Input() recommendedPlan: string | null = null;
    @Input() showHeading = true;
    @Input() hideIntervalToggle = false;
    // Stripe only: the user clicked a plan card and the subscription modal is
    // about to open.
    @Output() planSelected = new EventEmitter<string>();

    @ViewChild('checkoutRef') checkoutRef: SubscriptionPlansCheckoutComponent;

    SubscriptionInterval = SubscriptionInterval;

    constructor(private user: UserService, public subscription: SubscriptionService) { }

    get effectiveRecommendedPlan(): string {
        return (this.recommendedPlan || 'scale').toLowerCase();
    }

    get hasTrialExpired(): boolean {
        return this.user.hasTrialExpired;
    }

    get selectedInterval(): SubscriptionInterval {
        return this.subscription.selectedInterval;
    }

    get showIntervalToggle(): boolean {
        return !this.hideIntervalToggle && !this.subscription.isShopifyBillingProvider;
    }

    selectInterval(interval: SubscriptionInterval): void {
        this.subscription.selectedInterval = interval;
        this.checkoutRef?.selectInterval(interval);
    }

    onPlanSelected(plan: string): void {
        this.planSelected.emit(plan);
    }
}
